import { PageView, AdminLayout, BlankLayout } from '@/layouts';
import { getEnvironmentData } from '@/utils/env';
const { VITE_APP_PROJECT_NAME } = getEnvironmentData();
const defaultHomePageName = '/base/home';
export default [
  {
    path: '/',
    redirect: '/base',
  },
  {
    path: '/base',
    component: BlankLayout,
    redirect: defaultHomePageName, //'/policeSituation/policeSituationMonitoring',
    children: [
      {
        path: 'home',
        name: '/base/home',
        component: () => import('@/views/base/home'),
        meta: { title: '首页' },
        title: '首页',
      },
      {
        path: 'test',
        name: '/base/test',
        component: () => import('@/views/base/test'),
        meta: { title: '首页' },
        title: '首页',
      },
    ],
  },
];
